import "./index.scss";

import { Box } from "@mui/material";
import TitleWithOptions from "components/TitleWithOptions";
import { TMemberDetails } from "models/member";
import { useEffect, useState } from "react";

const InterestsSection = (props: { member: TMemberDetails; editCallback: Function }) => {
  const { member, editCallback } = props;
  const [interestsVisibile, setInterestsVisible] = useState(false);
  const [activityInterests, setActivityInterests] = useState([]);
  const [fitnessClassesInterests, setFitnessClassesInterests] = useState([]);
  const [otherInterests, setOtherInterests] = useState([]);

  useEffect(() => {
    if (member?.interests) {
      setInterestsVisible(true);
      setActivityInterests(member.interests["ACTIVITY_INTERESTS"] || []);
      setFitnessClassesInterests(member.interests["FITNESS_CLASSES"] || []);
      setOtherInterests(member.interests["OTHER_INTERESTS"] || []);
    }
  }, [member]);

  if (!interestsVisibile) return null;

  //console.log(`Activity Interests:\n${JSON.stringify(activityInterests)}`);
  //console.log(`Fitness Classes:\n${JSON.stringify(fitnessClassesInterests)}`);
  //console.log(`Other Interests:\n${JSON.stringify(otherInterests)}`);

  return (
    <Box className="interests-container">
      <TitleWithOptions title="Interests" edit={editCallback} />

      <Box className="interests-section-inner-container" display="flex" flexDirection="column">
        {activityInterests?.length > 0 && (
          <>
            <p className="title">Activity Interests</p>
            {activityInterests.map((m, i) => (
              <Box key={`personalDetailActivityInterest${i}`} className="capsule-text">
                {m.activity_title}
              </Box>
            ))}
          </>
        )}
        {fitnessClassesInterests?.length > 0 && (
          <>
            <p className="title">Fitness Classes</p>
            {fitnessClassesInterests.map((m, i) => (
              <Box key={`personalDetailFitnessClassesInterest${i}`} className="capsule-text">
                {m.activity_title}
              </Box>
            ))}
          </>
        )}
        {otherInterests?.length > 0 && (
          <>
            <p className="title">Other Interests</p>
            {otherInterests.map((m, i) => (
              <Box key={`personalDetailOtherInterest${i}`} className="capsule-text">
                {m.activity_title}
              </Box>
            ))}
          </>
        )}
      </Box>
    </Box>
  );
};

export default InterestsSection;
